export default __webpack_public_path__ + "static/media/mh-bedroom-master-01.a3166ec8.jpg";